import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'
import { TellowConstants } from '../enums/TellowConstants'
import { locale } from './i18n/nl'
import { ProspectService } from './services/prospect.service'
import { OriginService } from '../system/origins/origin.service'
import { OriginModel } from '../system/origins/models/origin.model'
import 'rxjs/add/operator/catch'
import 'rxjs/add/observable/throw'
import { Subscription } from 'rxjs/Subscription'
import { Prospect } from './prospect'
import * as moment from 'moment'
import { DateAdapter, MatSnackBar } from '@angular/material'
import { TranslateService } from '@ngx-translate/core'
import { AccountTemplateService } from './services/account-template.service'
import { AccountTemplateModel } from './AccountTemplateModel'

@Component({
  selector: 'app-prospect',
  templateUrl: './prospect.component.html',
  styleUrls: ['./prospect.component.scss'],
})
export class ProspectComponent implements OnInit, OnDestroy {
  origins: OriginModel[]
  accountTemplates: AccountTemplateModel[]
  prospectForm: FormGroup
  genders = TellowConstants.getGenders()
  errors: { [key: string]: string } = {}
  prospectData: Subscription
  isLoading = false

  @ViewChild('titleInput') titleInputField

  constructor(
    private formBuilder: FormBuilder,
    private translationLoader: FuseTranslationLoaderService,
    private prospectService: ProspectService,
    public snackBar: MatSnackBar,
    private translateService: TranslateService,
    private originService: OriginService,
    private accountTemplateService: AccountTemplateService,
  ) {
    this.translationLoader.loadTranslations(locale)
  }

  ngOnInit() {
    this.isLoading = true
    this.createProspecForm()

    this.prospectData = this.originService
      .list()
      .map(origins => {
        this.origins = origins.rows
      })
      .switchMap(() => this.accountTemplateService.list())
      .map(accountTemplates => {
        this.accountTemplates = accountTemplates
      })
      .subscribe(() => (this.isLoading = false))

    this.focusTitleField()
  }

  focusTitleField() {
    setTimeout(() => {
      this.titleInputField.nativeElement.focus()
    })
  }

  createProspecForm() {
    this.prospectForm = this.formBuilder.group({
      first_name: ['', [Validators.required]],
      middle_name: [''],
      last_name: ['', [Validators.required]],
      phone_number: ['', [Validators.required]],
      email: ['', [Validators.required]],
      date_of_birth: [''],
      gender: [''],
      origin: ['INTERNAL', Validators.required],
      company_name: ['', Validators.required],
      iban: ['', Validators.required],
      bic: ['', Validators.required],
      coc_number: [''],
      vat_number: [''],
      sbi: [],
      mobile_number: [''],
      address_street: [''],
      address_number: [''],
      address_number_addition: [''],
      address_postal_code: [''],
      address_city: [''],
      address_country: [''],
      salesforce_contact_id: [''],
      salesforce_account_id: [''],
      account_template_id: [''],
    })
  }

  /**
   *
   */
  addProspect(prospect: Prospect) {
    if ('' !== prospect.date_of_birth) {
      prospect.date_of_birth = moment(prospect.date_of_birth).format('YYYY-MM-DD')
    } else {
      prospect.date_of_birth = undefined
    }

    if ('' === prospect.gender) {
      prospect.gender = undefined
    }

    if (null !== prospect.sbi) {
      prospect.sbi = prospect.sbi.split(',')
    }

    this.prospectService.add(prospect).subscribe(
      user => {
        this.translateService.get('PROSPECT.PROSPECT_SAVED', {}).subscribe((message: string) => {
          this.openSnackBar(message, '')
        })
      },
      errors => {
        this.updateErrorMessages(errors.error.extra_data)
        this.translateService.get('PROSPECT.PROSPECT_SAVE_FAILED', {}).subscribe((message: string) => {
          this.openSnackBar(message, '')
        })
      },
    )
  }

  /**
   * Map Error messages with form properties
   * @param errors
   */
  updateErrorMessages(errors) {
    this.errors = {}

    if (errors != undefined) {
      for (const error of Object.keys(errors)) {
        const control = this.prospectForm.get(error)
        if (control) {
          this.errors[error] = errors[error]
          this.prospectForm.get(error).setErrors({
            errors: true,
          })
        }
      }
    }
  }

  /**
   *
   * @param {string} message
   * @param {string} action
   */
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    })
  }

  ngOnDestroy() {
    this.prospectData.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/prospect/prospect.component.ts